import React from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/nb'
import SearchComponent, { type SearchComponentProps } from '../../../react4xp/components/SearchComponent'
import type { SearchResultItem } from '../../../react4xp/components/SearchComponent/SearchResults'

const formatDate = (value?: string) => {
  if (!value) {
    return value
  }

  const parsedDate = dayjs(value)
  if (!parsedDate.isValid()) {
    return value
  }

  return parsedDate.locale('nb').format('DD. MMM YYYY')
}

const withFormattedDates = (items?: SearchResultItem[]) =>
  Array.isArray(items)
    ? items.map((item) => {
        if (item.type === 'news' && item.data.date) {
          return {
            ...item,
            data: {
              ...item.data,
              date: formatDate(item.data.date)
            }
          }
        }
        return item
      })
    : items

function SearchLayout({
  initialItems,
  nextPageUrl,
  filters,
  dateFilter,
  totalResults,
  searchTerm,
  searchValue,
  loadMoreText,
  minSearchLength,
  minSearchLengthMessage,
}: SearchComponentProps) {
  return (
    <SearchComponent
      initialItems={withFormattedDates(initialItems)}
      nextPageUrl={nextPageUrl}
      filters={filters}
      dateFilter={dateFilter}
      totalResults={totalResults}
      searchTerm={searchTerm}
      searchValue={searchValue}
      loadMoreText={loadMoreText}
      minSearchLength={minSearchLength}
      minSearchLengthMessage={minSearchLengthMessage}
    />
  )
}

export default (props) => <SearchLayout {...props} />
